
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { format } from "date-fns";
import { fr } from "date-fns/locale";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date, formatString: string = 'PP'): string {
  if (!date) return '';
  
  const dateObject = typeof date === 'string' ? new Date(date) : date;
  
  if (isNaN(dateObject.getTime())) {
    return '';
  }
  
  return format(dateObject, formatString, { locale: fr });
}

export function generateQuoteNumber(): string {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  // Generate a more unique random number (3 digits)
  const random = Math.floor(Math.random() * 900 + 100);
  
  return `DEV-${year}${month}${day}-${random}`;
}

/**
 * Format a number according to specified options
 */
export function formatNumber(
  value: number, 
  options: Intl.NumberFormatOptions = {}
): string {
  return new Intl.NumberFormat('fr-FR', options).format(value);
}

/**
 * Format time from HH:MM format to a readable format - using eventUtils instead
 */
export function formatTime(timeString: string | null): string {
  if (!timeString) return "—";
  
  try {
    if (timeString.includes(':')) {
      const [hours, minutes] = timeString.split(':');
      return minutes === '00' ? `${hours}h` : `${hours}h${minutes}`;
    }
    
    return timeString;
  } catch (error) {
    return timeString || "—";
  }
}
